import useCompanyService from "../api/services/useCompanyService";
import swal from "sweetalert";


const useValidateCoc = (id, form) => {
  const companyService = useCompanyService()

  const onClickValidateCoc = () => {
    if (form.formData.model.coc_number === null || form.formData.model.coc_number === '') {
      swal({
        title: 'Ful het KvK nummer in',
        icon: 'error',
        text: 'We hebben het KvK nummer nodig om de validatie te doen.',
        buttons: {
          confirm: {
            text: "Oke",
            value: true,
            visible: true,
            className: 'btn-color-grey btn-size-m',
            closeModal: true,
          }
        }
      })
      return;
    }

    companyService.userValidateCoc(
      (company) => {

        form.formData.model.is_verified = company.is_verified
        form.formData.model.coc_number = company.coc_number
        form.formData.model.legal_name = company.legal_name
        form.formData.model.coc_number_verified_at = company.coc_number_verified_at
        form.formData.model.legal_name_verified_at = company.legal_name_verified_at

        form.setOriginalFormDataModel.is_verified = company.is_verified
        form.setOriginalFormDataModel.coc_number = company.coc_number
        form.setOriginalFormDataModel.legal_name = company.legal_name
        form.setOriginalFormDataModel.coc_number_verified_at = company.coc_number_verified_at
        form.setOriginalFormDataModel.legal_name_verified_at = company.legal_name_verified_at

        form.save(form.formData.isChanged)

        if (company.coc_number_verified_at) {
          swal({
            title: 'Success',
            icon: 'success',
            text: 'Validatie Gelukt',
            buttons: {
              confirm: {
                text: "Oke",
                value: true,
                visible: true,
                className: 'btn-color-grey btn-size-m',
                closeModal: true,
              }
            }
          })
        } else {
          swal({
            title: 'Error',
            icon: 'error',
            text: 'Validatie Mislukt 3',
            buttons: {
              confirm: {
                text: "Oke",
                value: true,
                visible: true,
                className: 'btn-color-grey btn-size-m',
                closeModal: true,
              }
            }
          })
        }
      },
      () => {
      },
      id,
      form.formData.model.coc_number
    )
  }

  return {
    onClickValidateCoc,
  }
}

export default useValidateCoc
